.pill {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  padding: 2px var(--space-2);
  font-size: var(--text-xs);
  font-weight: var(--weight-medium);
  border-radius: var(--radius-full);
  white-space: nowrap;
  line-height: 1.6;
}

.neutral { background: var(--bg-sunken);     color: var(--text-muted); }
.success { background: var(--success-soft);  color: var(--success); }
.warning { background: var(--warning-soft);  color: var(--warning); }
.danger  { background: var(--danger-soft);   color: var(--danger); }
.info    { background: var(--info-soft);     color: var(--info); }
.indigo  { background: var(--indigo-soft);   color: var(--indigo); }
.teal    { background: var(--teal-soft);     color: var(--teal); }

/* Dot form: no fill, for cells where several pills would look noisy. */
.subtle {
  background: transparent;
  padding-left: 0;
  color: var(--text);
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  flex-shrink: 0;
}

.subtle.success { color: var(--success); }
.subtle.warning { color: var(--warning); }
.subtle.danger  { color: var(--danger); }
.subtle.info    { color: var(--info); }
